export default "__VITE_ASSET__BTU4Qycg__"